import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import { connect } from 'react-redux';
import { compose } from 'redux';
import cn from 'classnames';
import theme from '../../styles/theme';
import { isBreakpointSet, isCurrentBreakpointAtLeast } from '../../selectors';
import SideScroller from './SideScroller';

const SwitchingSideScroller = ({
  children,
  classes,
  className,
  Container,
  sideScrollerEnabled,
  ...rest
}) => (
  <Container
    className={cn(className, !sideScrollerEnabled && classes.withoutSideScroller)}
    {...(typeof Container === 'string' ? undefined : rest)}
  >
    {children}
  </Container>
);

SwitchingSideScroller.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
  ]).isRequired,
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  className: PropTypes.string,
  Container: PropTypes.oneOfType([PropTypes.func, PropTypes.string]).isRequired,
  sideScrollerEnabled: PropTypes.bool,
};

SwitchingSideScroller.defaultProps = {
  className: undefined,
  sideScrollerEnabled: false,
};

export default (OtherComponent, breakpoint, preHydrationSideScrollerStyles) => {
  const mapStateToProps = state => {
    const sideScrollerEnabled = isBreakpointSet(state)
      && !isCurrentBreakpointAtLeast(state, breakpoint);
    return {
      Container: sideScrollerEnabled ? SideScroller : OtherComponent,
      sideScrollerEnabled,
    };
  };

  const sideScrollerMediaQuery = theme.breakpoints.down(
    theme.breakpoints.keys[theme.breakpoints.keys.indexOf(breakpoint) - 1],
  );

  return compose(
    connect(mapStateToProps),

    injectSheet({
      withoutSideScroller: {
        display: 'flex',
        flexWrap: 'wrap',
        marginLeft: -theme.padding.gutter / 2,
        marginRight: -theme.padding.gutter / 2,
        [sideScrollerMediaQuery]: {
          // these styles are to make the mobile layout look like it will with SideScroller, but
          // before hydration when we haven’t yet switched to SideScroller
          flexWrap: 'nowrap',
          marginRight: -theme.padding.horizontal, // extend to the right-hand edge of the viewport
          overflow: 'hidden', // stop the page width blowing out
          ...preHydrationSideScrollerStyles,
        },
      },
    }),
  )(SwitchingSideScroller);
};
